<template>
  <zj-layout-container
    class="user-layout"
    v-loading="loading"
    :element-loading-text="loadingText"
  >
    <div class="zj-layout-left">
      <zj-layout-container>
        <zj-layout-main>
          <div class="zj-layout-main-content bgcolor scrollable">
            <el-form
              class="zj-search-form,faceleft"
              ref="form"
              :model="avatarobj"
              :label-width="labelWidth"
            >
              <el-row>
                <el-form-item label="搜索时间">
                  <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    unlink-panels
                    :clearable="false"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['09:00:00', '18:00:00']"
                  ></el-date-picker>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="排序方式" style="width: 100%">
                  <el-select
                    v-model="SoltKey"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option key label="无" value></el-option>
                    <el-option
                      v-for="item in Solt"
                      :key="item.value"
                      :label="item.lable"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="评分" style="width: 100%">
                  <el-select
                    v-model="scoreKey"
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option key label="全部"></el-option>
                    <el-option
                      v-for="item in score"
                      :key="item.value"
                      :label="item.lable"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row style="text-align: center">
                <el-form-item>
                  <div
                    style="width: 45rem; height: 45rem; border: 1px solid gray"
                  >
                    <el-avatar
                      v-if="avatarobj.url"
                      shape="square"
                      fit="fill"
                      :src="avatarobj.url"
                      style="width: 45rem; height: 45rem"
                    ></el-avatar>
                  </div>
                  <div class="UploadAuator">
                    <el-upload
                      :show-file-list="false"
                      accept="image/png, image/gif, image/jpg, image/jpeg"
                      :http-request="httpRequest"
                      :before-upload="beforeupload"
                      :on-success="uploadsuccess"
                      :on-progress="uploadProgress"
                      :on-error="uploadError"
                      :data="uploadData"
                      :file-list="fileList"
                    >
                      <div class="el-icon-upload UploadAuatorBtn">
                        点击上传人脸
                      </div>
                    </el-upload>
                  </div>
                </el-form-item>
              </el-row>
              <el-row style="text-align: center">
                <el-form-item label class="bottom">
                  <el-button @click="onReseat">重 置</el-button>
                  <el-button @click="onSearch">搜 索</el-button>
                  <!-- <el-button @click="onControlAvatar">布 控</el-button> -->
                </el-form-item>
              </el-row>
            </el-form>
          </div>
        </zj-layout-main>
        <zj-layout-footer></zj-layout-footer>
      </zj-layout-container>
    </div>
    <div class="zj-layout-right">
      <zj-layout-container>
        <zj-layout-header>
          <el-form>
            <el-form-item label class="right">
              <el-button @click="lookMap(this)" ref="mapPic">
                {{ showmapbtnText }}
              </el-button>
            </el-form-item>
          </el-form>
          <el-divider></el-divider>
        </zj-layout-header>
        <zj-layout-main>
          <div
            v-show="!showMap"
            class="zj-layout-main-content bgcolor scrollable"
          >
            <div style="width: 100%; height: auto">
              <div v-for="avatar in avatars" :key="avatar" class="avatar">
                <div>
                  <!-- <el-avatar
                    shape="square"
                    :size="120"
                    fit="fill"
                    :src="avatar.facePicUrl"
                  ></el-avatar>-->
                  <!--  ${imgBeforeUrl} :src="`https://docking.xjtstc.com/preview?file_id=${avatar.facePicUrl}`" -->
                  <img
                   :src="`${avatar.facePicUrl}`"
                    style="width: 20rem; height: 20rem"
                  />
                  <!-- <img
                    :src="'data:image/jpeg;base64,' + avatar.facePicUrlBase64"
                    style="width: 20rem; height: 20rem"
                  /> -->
                  <div style="padding: 0.5rem">{{ avatar.cameraName }}</div>
                  <div style="padding: 0.5rem">
                    {{ avatar.captureTime | formatDatSingle }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="showMap" class="map"></div>
        </zj-layout-main>
        <el-dialog
          v-dialogDrag
          title="提示"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleDialogClose"
        >
          <span>这是一段信息</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false"
              >确 定</el-button
            >
          </span>
        </el-dialog>
        <zj-layout-footer></zj-layout-footer>
      </zj-layout-container>
    </div>
  </zj-layout-container>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
// import { faceSearch } from "../request/api";
import { faceSearch } from "../../../../../../request/api";

export default {
  name: "FaceAuatarList",
  controller: "UI",
  action: "FaceAuatarList",
  props: {
    query: { type: Object, default: null },
  },
  data() {
    return {
      date: [
        new Date().format("yyyy-MM-dd 00:00:00"),
        new Date().format("yyyy-MM-dd 23:59:59"),
      ],
      avatarobj: {
        url: null,
      },
      Solt: [
        { lable: "时间", value: "Time" },
        { lable: "评分", value: "score" },
      ],
      SoltKey: "",
      score: [
        { lable: "90及以上", value: 90 },
        { lable: "80及以上", value: 80 },
        { lable: "70及以上", value: 70 },
        { lable: "65及以上", value: 65 },
      ],
      scoreKey: "",
      UploadDraw: true,
      uploadData: {
        //todo
        module: "人脸模块", //模块名
        submodule: "", //子模块
        assocID: "rlmk", //业务ID
        uploader: ZJApp.ZJUser.current.UserName, //上传人
        folder: "", //上传目录，服务器按如下格式拼装：/{module}/{submodule}/{folder}
        ext1: "", //扩展字段 1
        ext2: "", //扩展字段 2
        ext3: 0, //扩展字段 3
      },
      fileList: [],
      loading: false,
      loadingText: "加载中...",
      avatars: [],
      showMap: false,
      showmapbtnText: "查看轨迹",
      base64: "",
      monitorEquipments: [],
      avatarList: [],
      dialogVisible: false,
      imgBeforeUrl:global.$config.api.docking_url+"/preview?file_id="
    };
  },
  created: function () {
    // this.onDrawMap();
  },
  mounted() {
    if (this.query.avatarobj) {
      this.avatarobj = this.query.avatarobj;
      if(this.query.avatarobj.snapUrl.indexOf("http")==-1){
        this.avatarobj.url =this.imgBeforeUrl +this.query.avatarobj.snapUrl;
      }
      this.search();
    }
    this.getMonitorEquipments();
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
  filters: {
    formatDatSingle(data) {
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
  methods: {
    search() {
      this.avatars = [];
      let params = {
        page: 1,
        size: 10,
        startTime: new Date(this.date[0]).format("yyyy-MM-dd 00:00:00"),
        endTime: new Date(this.date[1]).format("yyyy-MM-dd 23:59:59"),
        minSimilarity: this.scoreKey || 10,
        imageBase64: this.avatarobj.url,
      };
      this.imgToBase64(params);
    },
    getMonitorEquipments() {
      let searchInfo = {
        EquipmentType: "Monitor", //设备类型
        PageSize: 10000,
        PageIndex: 1,
      };
      new MyApis.MonitorApi()
        .GetEquipmentPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.monitorEquipments = r.PageContents;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    onReseat() {
      this.avatarobj.url = null;
      this.SoltKey = "";
      this.scoreKey = "";
      this.date = [new Date(), new Date()];
      this.avatars = [];
      // eslint-disable-next-line no-undef
      //$(".map").empty();
    },
    handleDialogClose() {
      this.$confirm("确认关闭？")
        .then(() => {
          this.dialogVisible = false;
        })
        .catch(() => {});
    },
    onSearch() {
      if (!this.avatarobj.url) {
        this.errmsg("查询失败，请上传照片 ");
        return;
      }
      this.search();
    },
    imgToBase64(params) {
      this.loading = true;
      this.loadingText = "搜索中...";
      var base64 = "";
      var img = new Image();
      img.src = params.imageBase64;
      let that = this;
      img.setAttribute("crossOrigin", "Anonymous");
      img.onload = function () {
        base64 = that.image2Base64(img);
        const index = base64.indexOf(",");
        base64 = base64.slice(index + 1);

        params.imageBase64 = base64;
        let paramsAll={
          baseUrl:global.$config.api.docking_url,
          data:params
        }
        faceSearch(paramsAll)
          .then((res) => {
            that.loading = false;
            if (res.code == 0 && res.data) {
              that.avatars = res.data.list;
              that.avatars.forEach(item=>{
                if(item.facePicUrl.indexOf("http")==-1){
                  item.facePicUrl = that.imgBeforeUrl+item.facePicUrl;
                }
              })
              that.avatars = that.avatars.sort(function (a, b) {
                let result = that.compareDate(a.captureTime,b.captureTime);
                if(result){
                  return 1
                }else{
                  return -1
                }
                // return b.captureTime < a.captureTime ? 1 : -1;
              });
              console.log("that.avatars")
              console.log(that.avatars)
            }
            if (that.avatars && that.avatars.length > 0) {
              that.onDrawMap();
            } else {
              that.$message.info("未搜索到相关资源");
            }
          })
          .catch((e) => {
            console.error(e);
            that.loading = false;
            that.$message({
              message: e.RspMsg ? e.RspMsg : "人脸查询失败！",
              type: "error",
            });
          });
      };
    },
    compareDate(date1,date2){
        var oDate1 = new Date(date1);
        var oDate2 = new Date(date2);
        if(oDate1.getTime() > oDate2.getTime()){
            return true; //第一个大
        } else {
            return false; //第二个大
        }
    },
    image2Base64(img) {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, img.width, img.height);
      var dataURL = canvas.toDataURL("image/jpeg");
      return dataURL;
    },
    beforeupload: function () {
      this.loading = true;
      this.loadingText = "上传中... 0%";
    },
    uploadsuccess: function (response) {
      this.loading = false;
      if (response.url) {
        this.avatarobj = {};
        this.avatarobj.url = response.url;
        this.search();
      }
    },
    uploadError(err) {
      console.error("上传失败: ", err);
      this.errmsg("上传失败: " + err);
      this.loading = false;
    },
    uploadProgress(e) {
      this.loadingText = "上传中... " + parseInt(e.percent) + "%";
    },
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    lookMap() {
      if (this.showMap) {
        this.showMap = false;
        this.showmapbtnText = "查看轨迹";
      } else {
        this.showMap = true;
        this.showmapbtnText = "查看列表";
        // this.drawFaceTrack();
        this.initMap();
      }
    },
    initMap() {
      //var map = new BMap.Map("allmap"); // 创建Map实例
      //  map.enableScrollWheelZoom();
      const that = this;
      let mapE = {};
      this.avatarList = [];

      that.monitorEquipments.forEach((element) => {
        mapE[element.DeviceId] = {
          DeviceId: element.DeviceId,
          DeviceName: element.DeviceName,
          Longitude: element.Longitude,
          Latitude: element.Latitude,
        };
      });
      that.avatars.forEach((item) => {
        let avatar = {};
        if (mapE[item.cameraIndexCode]) {
          avatar = item;
          avatar.Longitude = mapE[item.cameraIndexCode].Longitude;
          avatar.Latitude = mapE[item.cameraIndexCode].Latitude;
          avatar.DeviceName = mapE[item.cameraIndexCode].DeviceName;
        }
        this.avatarList.push(avatar);
      });
      this.avatarList = this.avatarList.sort(function (a, b) {
        return b.captureTime < a.captureTime ? 1 : -1;
      });
     console.log("this.avatarList")
     console.log(this.avatarList)
    //  console.log(JSON.stringify(this.avatarList))
      if (this.avatarList != null && this.avatarList.length > 0) {
        var mapInstance = that.mapInstance;
        var map = mapInstance.map;
        map.addControl(new BMap.NavigationControl()); // 添加平移缩放控件
        map.addControl(new BMap.ScaleControl()); // 添加比例尺控件
        map.addControl(new BMap.OverviewMapControl()); //添加缩略地图控件
        map.clearOverlays();
        map.enableScrollWheelZoom();
        //   map.addControl(new BMap.ScaleControl());
        var PointArr = [];
        for (var i = 0; i < this.avatarList.length; i++) {
          if (
            this.avatarList[i].Latitude != 0 &&
            this.avatarList[i].Longitude != 0
          ) {
            PointArr.push({
              lat: this.avatarList[i].Latitude,
              lng: this.avatarList[i].Longitude,
              // picUrl: "https://docking.xjtstc.com/preview?file_id="+this.avatarList[i].facePicUrl, 
              picUrl:   this.avatarList[i].facePicUrl, 
              DeviceName: this.avatarList[i].DeviceName,
              CaptureTime: this.avatarList[i].captureTime,
            });
          }
        }
        that.addStartMarker(
          new BMap.Point(PointArr[0].lng, PointArr[0].lat),
          PointArr,
          map
        );

        that.addMarkerEnd(
          new BMap.Point(
            PointArr[PointArr.length - 1].lng,
            PointArr[PointArr.length - 1].lat
          ),
          PointArr,
          map
        );
        //  map.centerAndZoom(PointArr, 13); //根据经纬度显示地图的范围
        // map.setViewport(PointArr); //根据提供的地理区域或者坐标设置地图的视野
        // 百度地图API功能

        var MapIcon = new BMap.Symbol(BMap_Symbol_SHAPE_BACKWARD_OPEN_ARROW, {
          scale: 0.6, //图标缩放大小
          strokeColor: "#ffffff", //设置矢量图标线填充颜色
          strokeWeight: "1", //设置线宽
        });

        var icons = new BMap.IconSequence(MapIcon, "10", "30");

        var pois = [];

        // var i = 0;

        for (var j = 0; j < PointArr.length; j++) {
          pois.push(new BMap.Point(PointArr[j].lng, PointArr[j].lat));
        }

        var polyline = new BMap.Polyline(pois, {
          enableEditing: false, //是否启用线编辑，默认为false

          enableClicking: true, //是否响应点击事件，默认为true

          icons: [icons],

          strokeWeight: "5", //折线的宽度，以像素为单位

          strokeOpacity: 1, //折线的透明度，取值范围0 - 1

          strokeColor: "#349c00", //折线颜色
        });

        map.addOverlay(polyline);
        // 向地图添加标注
        for (var m = 0; m < PointArr.length; m++) {
          this.addMarker(PointArr[m], PointArr);
        }
      }
    },
    //添加起点图标

    addStartMarker(point, PointArr, mapInit) {
      var myIcon = new BMap.Icon(
        PointArr[0].picUrl,
        // "data:image/jpeg;base64," + PointArr[0].picUrl,
        new BMap.Size(45, 45),
        {
          anchor: new BMap.Size(10, 25), //这句表示图片相对于所加的点的位置mapStart
          // anchor: new BMap.Size(20, 45), //这句表示图片相对于所加的点的位置mapStart

          imageSize: new BMap.Size(45, 45), //图标所用的图片的大小，此功能的作用等同于CSS中的background-size属性。可用于实现高清屏的高清效果
        }
      );

      window.marker = new BMap.Marker(point, { icon: myIcon }); // 创建标注
      var label = new BMap.Label(
        "<center><strong>" + "起点",
        // eslint-disable-next-line no-undef
        { position: point[0], offset: new BMap.Size(-30, -10) }
        // { position: point[0], offset: new BMap.Size(-50, -70) }
      );
      label.setStyle({
        color: "blue",
        border: "#409eff 1px solid",
        background: "#329c12",
      });
      marker.setLabel(label);

      mapInit.addOverlay(marker);
    },

    //添加结束图标

    addMarkerEnd(point, PointArr, mapInit) {
      var myIcon = new BMap.Icon(
        PointArr[PointArr.length - 1].picUrl,
        // "data:image/jpeg;base64," + PointArr[PointArr.length - 1].picUrl,
        new BMap.Size(45, 45),
        {
          anchor: new BMap.Size(10, 25), //这句表示图片相对于所加的点的位置mapStart
          // anchor: new BMap.Size(20, 45), //这句表示图片相对于所加的点的位置mapStart

          imageSize: new BMap.Size(45, 45), //图标所用的图片的大小，此功能的作用等同于CSS中的background-size属性。可用于实现高清屏的高清效果
        }
      );

      window.marker = new BMap.Marker(point, { icon: myIcon }); // 创建标注
      var label = new BMap.Label(
        "<center><strong>" + "终点",
        // eslint-disable-next-line no-undef
        { position: point[0], offset: new BMap.Size(-20, -10) }
        // { position: point[0], offset: new BMap.Size(-50, -30) }
      );
      label.setStyle({
        color: "blue",
        border: "#409eff 1px solid",
        background: "#329c12",
      });
      marker.setLabel(label);
      mapInit.addOverlay(marker);
    },
    addMarker(point, PointArr) {
      const that = this;
      var mapInstance = that.mapInstance;
      var map = mapInstance.map;
      var myIcon = new BMap.Icon(
        point.picUrl,
        // "data:image/jpeg;base64," + point.picUrl,
        new BMap.Size(45, 45),
        {
          anchor: new BMap.Size(20, 45), //这句表示图片相对于所加的点的位置mapStart

          imageSize: new BMap.Size(45, 45), //图标所用的图片的大小，此功能的作用等同于CSS中的background-size属性。可用于实现高清屏的高清效果
        }
      );
      var marker = new BMap.Marker(new BMap.Point(point.lng, point.lat), {
        icon: myIcon,
      }); // 创建标注

      var label = new BMap.Label(
        "<center><strong>" + "监控点" + ":" + point.DeviceName,
        // eslint-disable-next-line no-undef
        { position: point[0], offset: new BMap.Size(-20, -20) }
        // { position: point[0], offset: new BMap.Size(-50, -50) }
      );
      label.setStyle({
        color: "blue",
        border: "#409eff 1px solid",
        background: "#329c12",
      });
      marker.setLabel(label);
      //    markers.push(marker);
      map.addOverlay(marker);

      marker.addEventListener("click", function () {
        that.showMessage(map, point, PointArr);
        //   this.openInfoWindow(new BMap.InfoWindow(p.toString(),PointArr[p]));
      });
    },
    showMessage(map, point, pointArr) {
      var opts = {
        width: 360, // 信息窗口宽度
        height: 340, // 信息窗口高度
        title: "<h4>" + point.DeviceName + "</h4>", // 信息窗口标题
        enableMessage: true, //设置允许信息窗发送短息
        message: "",
      };
      var imgHtml = "";
      var sContent =
        "<div>" +
        "  <ul>" +
        " </li>" +
        "    <li><label>经度:</label> <span style='font-size:14px;'>" +
        point.lng +
        "</span></li>" +
        "    <li><label>纬度:</label> <span style='font-size:14px;'>" +
        point.lat +
        "</span></li>";

      const points = pointArr.filter((item) => {
        return item.DeviceName === point.DeviceName;
      });
      for (var i = 0; i < points.length; i++) {
        imgHtml +=
          '<div class="avatar"><div><img style="width: 17rem; height: 17rem" src="'+
          points[i].picUrl +
          '"/>' +
          '<div style="padding: 0.5rem;font-size:14px;">' +
          new Date(points[i].CaptureTime).format("yyyy-MM-dd hh:mm:ss") +
          "</div></div></div>";
      }
      var eContent = "  </ul>" + "</div>";
      var content = sContent + imgHtml + eContent;
      var infoWindow = new BMap.InfoWindow(content, opts);
      var poi = new BMap.Point(point.lng, point.lat);
      // var map = this.mapInstance.map;
      map.openInfoWindow(infoWindow, poi);
    },

    drawFaceTrack() {
      const that = this;
      let mapE = {};
      this.avatarList = [];

      that.monitorEquipments.forEach((element) => {
        mapE[element.DeviceId] = {
          DeviceId: element.DeviceId,
          DeviceName: element.DeviceName,
          Longitude: element.Longitude,
          Latitude: element.Latitude,
        };
      });
      that.avatars.forEach((item) => {
        let avatar = {};
        if (mapE[item.cameraIndexCode]) {
          avatar = item;
          avatar.Longitude = mapE[item.cameraIndexCode].Longitude;
          avatar.Latitude = mapE[item.cameraIndexCode].Latitude;
          avatar.DeviceName = mapE[item.cameraIndexCode].DeviceName;
        }
        this.avatarList.push(avatar);
      });
      if (this.avatarList != null && this.avatarList.length > 0) {
        var mapInstance = that.mapInstance;
        var map = mapInstance.map;
        // eslint-disable-next-line no-undef
        var driving = new BMap.DrivingRoute(map); //创建驾车实例
        // 生成坐标点
        var trackPoint = [];
        for (var i = 0, j = this.avatarList.length; i < j; i++) {
          trackPoint.push(
            new BMap.Point(
              this.avatarList[i].Longitude,
              this.avatarList[i].Latitude
            )
          );
        }
        for (var i = 0; i < trackPoint.length; i++) {
          if (i != trackPoint.length - 1) {
            driving.search(trackPoint[i], trackPoint[i + 1]);
          }
        }
        driving.setSearchCompleteCallback(function () {
          var pts = driving.getResults().getPlan(0).getRoute(0).getPath(); //通过驾车实例，获得一系列点的数组
          // eslint-disable-next-line no-undef
          var polyline = new BMap.Polyline(pts);

          map.addOverlay(polyline);

          // 画图标、想要展示的起点终点途经点
          for (var i = 0; i < trackPoint.length; i++) {
            var lab;
            if (i == 0) {
              // eslint-disable-next-line no-undef
              lab = new BMap.Label("起点", { position: trackPoint[i] });
            } else if (i == trackPoint.length - 1) {
              // eslint-disable-next-line no-undef
              lab = new BMap.Label("终点", { position: trackPoint[i] });
            } else {
              /* lab = new BMap.Label("途径点",{position:trackPoint[i]}) */
            }
            // eslint-disable-next-line no-undef
            var marker = new BMap.Marker(trackPoint[i]);
            map.addOverlay(marker);
            map.addOverlay(lab);
          }
          map.setViewport(trackPoint);
        });
      }
    },

    onDrawMap: function () {
      this.$nextTick(function () {
        // 创建地图，并通过样式让地图填满窗口
        let that = this;
        // eslint-disable-next-line no-undef
        $(function () {
          // 不传入 syscode 和 key ，或者值为空时，
          // zjumap 插件自动从 URL 地址
          // http://HOST:PORT/Areas/Map/Content/UMap.html?syscode=xxx&key=yyy
          // 中读取 syscode 和 key 的值。
          // eslint-disable-next-line no-undef
          $(".map").zjumap({
            syscode: "ZJMap",
            key: "FaceMap",
            loading: ".global-loading",
            loadingText: ".global-loading-text",
            //地图配置
            mapConfigs: {
              mapStyle: "",
              togglePanelVisiable: false,
              // mapLayers: "DOM",
              // clickToShowLocation: false,
              // reportGeo: true,
              // onGotGeo: function(e) {
              //   e.handled = true;
              //   if (that.marker) {
              //     that.marker.setPosition(
              //       e.map.newPoint(e.point.lng, e.point.lat)
              //     );
              //   } else {
              //     //that.marker = that.addMarker(e.map, e.point);
              //   }
              //   that.dialogVisible2 = true;
              //   that.lat = e.point.lat;
              //   that.lng = e.point.lng;
              // },
              onMapCreated: function (e) {
                that.mapInstance = e.map;
                // e.map.clearAll();
                that.center = e.map.config.center;
                setTimeout(() => {
                  //  that.addDom();
                }, 1000);
              },
            },
          });
        });
      });
    },
    //布控
    onControlAvatar() {
      this.$router.push({
        path: "/plugin/Face/UI/FaceAddControl",
        query: { url: this.avatarobj.url, date: new Date() },
      });
    },
  },
};
</script>
<style scoped>
.faceleft .el-form-item .el-form-item__content {
  width: 100%;
}
.UploadAuator {
  width: 30rem;
  height: 5rem;
  position: relative;
  top: -5rem;
  left: 8rem;
  border-radius: 1rem;
  background-color: #386bff;
}
.UploadAuatorBtn {
  width: 30rem;
  font-size: 2rem;
  text-align: center;
  line-height: 5rem;
  height: 100%;
}
/* /deep/.BMap_pop .BMap_top {
  border-top: 1px solid rgba(61, 159, 255) !important;
  background-color: rgba(61, 159, 255, 0.2) !important;
}*/

/deep/.BMap_bubble_content {
  background-color: rgba(61, 159, 255, 0.2) !important;
  height: 325px !important;
  overflow-y: auto;
}
/*
/deep/.BMap_mask {
  overflow: auto;
}
/deep/.BMap_pop .BMap_center {
    border-left: 1px solid rgba(61, 159, 255) !important;
    border-right: 1px solid rgba(61, 159, 255) !important;
    background-color: rgba(61, 159, 255, 0.2) !important;
}
/deep/.BMap_pop div:nth-child(9) {
	top:35px !important;
	border-radius:7px;
}
*/
/*/deep/.BMap_pop img {
	top:5px !important;

}*/
/*/deep/.BMap_top {
	display:none;
}
/deep/.BMap_bottom {
	display:none;
}
.BMap_center {
	display:none;
}

/deep/.BMap_pop div:nth-child(1) div {
	display:none;
}
/deep/.BMap_pop div:nth-child(3) {
	display:none;
}
/deep/.BMap_pop div:nth-child(5) {
	display:none;
}
/deep/.BMap_pop div:nth-child(7) {
	display:none;
} */
</style>
